<template>
  <v-expansion-panel dark inset>
    <v-expansion-panel-content v-for="(item, index) in items" :key="index">
      <div slot="header">
        <h2>{{ item.lHeader }}</h2>
        <p>{{ item.rHeader }}</p>
        <p v-if="item.description">{{ item.description }}</p>
      </div>
      <v-list>
        <template v-for="lItem in item.tasks">
          <v-divider :key="lItem"></v-divider>
          <v-list-tile :key="lItem">
            <v-list-tile-content>
              <v-list-tile-title v-html="lItem"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "ResumeSkills",
  data() {
    return {
      items: [
        {
          lHeader: "Programming Languages",
          rHeader: "",
          tasks: [
            "C",
            "C++",
            "Haskell",
            "Rust",
            "Python",
            "Ruby",
            "JavaScript",
            "Verilog & System Verilog"
          ],
          description: null,
          link: ""
        },
        {
          lHeader: "Technologies",
          rHeader: "",
          tasks: [
            "Docker",
            "Kubernetes",
            "MS Azure",
            "Git",
            "Elasticsearch",
            "Neo4j",
            "MongoDB"
          ],
          description: null,
          link: ""
        }
      ]
    };
  }
};
</script>

<style scoped></style>
